import React from 'react';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import { Typography, Grid, Button } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';
import renderHTML from 'html-react-parser';
import { submissionModelName } from 'utils/contentHelper';

export class ThanksPage extends React.Component {
  render() {
    const { submission, promotion } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h4" sx={{typography: {xs: 'h5', sm: 'h4'}}} gutterBottom align="center" role="alert" aria-atomic="true">
          Congratulations!
        </Typography>

        <CheckCircle style={{color: green[500], fontSize: 70, margin: '20px auto', display: 'block'}} />

        {submission &&
          <React.Fragment>
            <Typography variant="headline" paragraph align="center" role="alert" aria-atomic="true">
              Your {submissionModelName(promotion)} has been submitted successfully
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              <Typography className="block" variant="body1" paragraph align="center">
                 A confirmation has been sent to you via the email address you provided.&nbsp;
                 {promotion.trackable && `You can also use the following ${submissionModelName(promotion, true)} ID to follow the status of your ${submissionModelName(promotion)}.`}
              </Typography>
              <Typography className="block" variant="headline" gutterBottom align="center">
                {submissionModelName(promotion, true)} ID: {submission.tracking_id}
              </Typography>
              {promotion.thank_you_page_content &&
                <Typography className="block" variant="body1" paragraph align="center">
                  <div>{renderHTML(promotion.thank_you_page_content)}</div>
                </Typography>
              }
              <Typography className="block" variant="body1" paragraph align="center">
                Thank you.
              </Typography>
              {promotion.extra_claim_cta &&
                <Button
                  component={NavLink}
                  to={{pathname: '/claim', search: this.props.location.search}}
                  variant="text"
                  size="large">Make another claim
                </Button>
              }
            </Grid>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    ...state.submission
  };
}

export default withRouter(connect(mapStateToProps)(ThanksPage));
